import React, { useState } from "react";
import { useTheme } from "@emotion/react";

import Grid from '@mui/material/Unstable_Grid2';
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Box from "@mui/material/Box";

import JSONEditor, { DiffEditor } from "@monaco-editor/react";

const EditorHeader = ({ header, view, setView, errorsCount }) => {
  const handleChange = (event, view) => {
    if (view !== null) {
      setView(view);
    }
  };

  return (
    <Stack
      direction="row"
      sx={{ display: "flex", justifyContent: "space-between", paddingRight: "14px" }}
      spacing={2}
    >
      <Typography
        variant="h5"
        noWrap
        sx={{
          mr: 2,
          display: { xs: "none", md: "flex" },
          fontWeight: 700,
          letterSpacing: ".3rem",
          textDecoration: "none",
        }}
        color="primary"
      >
        {header}
      </Typography>
      <Box display="flex" justifyContent="flex-end">
        <Typography
          variant="subtitle1"
          noWrap
          sx={{
            mr: 2,
            display: { xs: "none", md: "flex" },
            textDecoration: "none",
            paddingTop: "2px"
          }}
          color="error"
        >
          {errorsCount > 1 && `There are ${errorsCount} syntax errors in your JSON`}
          {errorsCount === 1 && `There is a syntax error in your JSON`}
        </Typography>
        <ToggleButtonGroup
          color="primary"
          value={view}
          exclusive
          onChange={handleChange}
          aria-label="Editor view"
          size="small"
          sx={{ "> button": { padding: "0px 15px" } }}
        >
          <ToggleButton size="medium" fullWidth value="edit">
            Edit
          </ToggleButton>
          <ToggleButton size="medium" fullWidth value="diff">
            Diff
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>
    </Stack>
  );
}


export const Editor = ({ json, handleJsonChange, handleValidationErrors, pristineJson, setView, view, header }) => {
  const theme = useTheme();
  const [errorsCount, setErrorsCount] = useState(0);

  const wrapErrorHandler = (markers) => {
    setErrorsCount(markers.length);
    handleValidationErrors(markers);
  }

  return (
    <Box>
      <Grid container spacing={1}>
        <Grid xs={12}>
          <EditorHeader
            header={header}
            view={view}
            setView={setView}
            errorsCount={errorsCount}
          />
        </Grid>
        <Grid xs={3}></Grid>
        <Grid xs={12}>
          {view === "diff" && (
            <DiffEditor
              height="32.5vh"
              width="100%"
              defaultLanguage="json"
              language="json"
              theme={theme.palette.mode === "light" ? "light" : "vs-dark"}
              original={JSON.stringify(json, null, 2)}
              modified={JSON.stringify(pristineJson, null, 2)}
              options={{
                contextmenu: false,
                renderValidationDecorations: "on",
                readOnly: true,
              }}
            />
          )}
          {view === "edit" && (
            <JSONEditor
              height="32.5vh"
              width="100%"
              defaultLanguage="json"
              language="json"
              theme={theme.palette.mode === "light" ? "light" : "vs-dark"}
              value={JSON.stringify(json, null, 2)}
              onChange={handleJsonChange}
              onValidate={wrapErrorHandler}
              options={{
                contextmenu: false,
                renderValidationDecorations: "on",
              }}
            />
          )}
        </Grid>
      </Grid>
    </Box>
  );
};
